import { Text } from 'ui-kit/typography'
import { BuilderCustomBuildDataType } from './builderCustomBuildData'
import classes from './BuilderCustomBuild.module.scss'

export const BuilderCustomBuildCard = ({
  item,
}: {
  item: BuilderCustomBuildDataType
}) => {
  return (
    <li className={classes.item}>
      <Text size={'lg'} lh={'tight'} center className={classes.desc}>
        {item.description}
      </Text>
    </li>
  )
}
